import "./style.css";

export interface FooterProps {
  handleOpenBottomSheet: () => void;
}

export const Footer = ({ handleOpenBottomSheet }: FooterProps) => {
  const referralCode = new URLSearchParams(window.location.search).get("code");

  const url = referralCode
    ? `https://dominoapp.onelink.me/vY2c/2u1bcxu8?inviteCode=${referralCode}&deep_link_sub1=${referralCode}`
    : "https://dominoapp.onelink.me/vY2c";

  return (
    <div className="footer">
      <div className="footer__bar">
        <div className="footer__btn" onClick={handleOpenBottomSheet} />
        <div className="bar">
          <div className="bar__left">
            <img className="bar__image" src="/images/appIcon.png" alt="" />
            <span className="bar__description">
              빠르게 한눈에{"\n"}
              모든 투자를 트래킹, 도미노
            </span>
          </div>
          <a className="bar__btn" href={url}>
            설치
          </a>
        </div>
      </div>
    </div>
  );
};
